import { useQuery } from '@tanstack/react-query';
import { createStripeSubscriptionManagementUrl } from 'shared/services/backend-api';
import { ID } from 'shared/types/id';

// Stripe management-portal sessions are valid ~5 min. Drives the cache window
// AND how long the fetched url stays shown before the "Beheren" button returns
// (see use-open-subscription-management → useExpiringValue). Lower it to test.
export const STRIPE_MANAGEMENT_URL_TTL_MS = 5 * 60 * 1000;
export const queryKey = 'stripe-management-url';

export const useStripeSubscriptionManagementUrlQuery = (
  stripeCustomerId: ID | undefined,
) =>
  useQuery<string | null>({
    queryKey: [queryKey, stripeCustomerId],
    queryFn: () => {
      if (!stripeCustomerId) {
        throw new Error('stripeCustomerId is required to fetch management url');
      }
      return createStripeSubscriptionManagementUrl(stripeCustomerId);
    },
    enabled: false,
    // Seed with data so the query is never in the pending state that, under the
    // global suspense default, would suspend the whole subscriptions section on
    // fetch. isFetching still drives the button's loading state.
    initialData: null,
    staleTime: STRIPE_MANAGEMENT_URL_TTL_MS,
    gcTime: STRIPE_MANAGEMENT_URL_TTL_MS,
  });
